import { React, useState, useEffect } from "react";
import TournamentBox from "../Tournament/TournamentBox/TournamentBox";
import RulesPopup from "../Popup/RulesPopup";
import WinningBreakup from "../Popup/WinningPopup";
import TournamentRoundPopup from "../Popup/SelectRoundPopup";
import JoiningPopup from "../Popup/JoiningPopup";

import { useNavigate } from "react-router";
import Popup from "../Popup/BasePopup";
import NewUserInGameNamePopUp from "../UserInGameName/NewUserInGameName";
import Button from "../CommonFields/Button";
import { toastSuccess, toastError } from "../../Utilities/toast";
import ScrimBox from "../PrivateScrims/ScrimBox/ScrimBox";
import { scrimById, scrimJoin } from "../../api/scrim.api";
import NonPremiumMaxJoinPopup from "./NonPremiumMaxJoin";
import { t } from "i18next";
import JoiningScrimPopup from "../Popup/JoiningScrimPopup";

const ScrimViaCode = ({ children, joinViaCodePrivateContest }) => {
    const [isPopupOpenTournament, setPopupOpenTournament] = useState(true);
    const [isSubscriptionPopup, setSubscriptionPop] = useState(false);
    const [isJoiningPopup, setJoiningPopup] = useState(false);
    const [gamerjiName, setGamerjiName] = useState(JSON.parse(localStorage.getItem("profile"))?.gamerjiName);
    const [uniqueIgn, setUniqueIgn] = useState(null);
    const [isDisableJoinBtn, setIsDisableJoinBtn] = useState(false);

    const navigate = useNavigate();
    console.log("sdfds")

    const onJoinScrimClick = (scrim) => {
        console.log("sdfds")
        setIsDisableJoinBtn(false);
        setJoiningPopup(true);
        // joinScrim()
    }

    const joinScrim = async () => {
        try {
            
            if (gamerjiName == null || gamerjiName.trim() === '') {
                setJoiningPopup(false);
                toastError(t("private-scrims.gamerji_name_required"));
                return
            }
            if (uniqueIgn == null || uniqueIgn.trim() === '') {
                setJoiningPopup(false);
                toastError(t("private-scrims.ingamename_required"));
                return
            }
            if (
                joinViaCodePrivateContest?.gameTypeAry?.players &&
                parseInt(joinViaCodePrivateContest?.gameTypeAry?.players) > 1
            ) {
                let data = {
                    scrimId: joinViaCodePrivateContest?._id,
                    isActive: true,
                    type: "contest",
                    // currencyCode: joinViaCodePrivateContest?.currency?.[0]?.inCurrency?._id, //TODO: need to use get currency is function here avoid direct use incurrency 
                    inGameUserName: uniqueIgn,
                    uniqueIGN: uniqueIgn,
                    gamerJiName: JSON.parse(localStorage.getItem("profile"))?.gamerjiName,
                    user: JSON.parse(localStorage.getItem("profile"))?.user_id
                };

                data.players = joinViaCodePrivateContest?.gameTypeAry?.players
                data.extraPlayers = joinViaCodePrivateContest?.gameTypeAry?.extraPlayers
                data.game_type = joinViaCodePrivateContest?.gameTypeAry?._id
                data.game = joinViaCodePrivateContest?.gameAry[0]?._id
                localStorage.setItem("registerData", JSON.stringify(data))
                localStorage.setItem("registerType", "scrim")
                setJoiningPopup(false);
                navigate("/team-registration")
            } else {

                let data = {
                    scrimId: joinViaCodePrivateContest?._id,
                    usersInGameName: uniqueIgn,
                    gamerJiName: JSON.parse(localStorage.getItem("profile"))?.gamerjiName
                };
                const res = await scrimJoin(data);
                if (res?.success && res?.data) {
                    toastSuccess('Contest Join Successfully!');
                    navigate(`/private-contest/detail/${res?.data?.data?.scrimId}`)
                }
                else {
                    if (res?.data?.errors[0]?.code === "joinUserContests.messages.max_limit_exceed") {
                        setJoiningPopup(false);
                        setSubscriptionPop(true)
                    } else {
                        setJoiningPopup(false);
                        toastError(res?.data?.errors?.[0]?.msg);
                    }
                }
            }
        } catch (error) {
            setJoiningPopup(false);
            console.log(error)
        }
    };

    return (
        <>
            {isPopupOpenTournament && (
                <Popup isOpen={isPopupOpenTournament} title={localStorage?.getItem('activeGame')?.toLocaleLowerCase() || "pubg"} onClose={() => setPopupOpenTournament(false)}>
                    <ScrimBox scrimData={joinViaCodePrivateContest} onJoinScrimClick={onJoinScrimClick} />
                </Popup>
            )}
            {isJoiningPopup && (
                <JoiningScrimPopup  // contest Join popup
                    isOpen={isJoiningPopup}
                    title={joinViaCodePrivateContest?.title}
                    popupType={'contest'}
                    contest={joinViaCodePrivateContest}
                    setingameName={setUniqueIgn}
                    onJoinContest={joinScrim}
                    onClose={() => setJoiningPopup(false)}
                    isDisableJoinBtn={isDisableJoinBtn}
                    setIsDisableJoinBtn={setIsDisableJoinBtn}
                />
            )}

            {isSubscriptionPopup && (
                <NonPremiumMaxJoinPopup
                    isOpen={isSubscriptionPopup}
                    message={t('premium.you_have_already_joined_today', { title: "scrim", total: localStorage?.getItem('noOfPrivateContest') })}
                    onClose={() => setSubscriptionPop(false)} title={"explore vi premium"}
                    onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }} />
            )}
        </>
    );
};

export default ScrimViaCode;